module.exports = __webpack_public_path__ + "static/media/RecordingIcon.7f1c763e.svg";